/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type CallCampaignAdvertiser = {
  __typename?: 'CallCampaignAdvertiser';
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type CallCampaignDay = {
  __typename?: 'CallCampaignDay';
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

export type CallCampaignPayload = {
  call_type: Scalars['String'];
  device: Scalars['String'];
  experiment_id: Scalars['String'];
  placement: Scalars['String'];
  product: Scalars['String'];
  profile: CallCampaignProfile;
  publisher_click_id: Scalars['String'];
  request_url: Scalars['String'];
  session_id: Scalars['String'];
  site: Scalars['String'];
  src: Scalars['String'];
  state: Scalars['String'];
  sub_id: Scalars['String'];
  user_id: Scalars['String'];
  variation_id: Scalars['String'];
  zip: Scalars['String'];
};

export type CallCampaignPhone = {
  __typename?: 'CallCampaignPhone';
  link_invoca?: Maybe<Scalars['String']>;
  promo_number?: Maybe<Scalars['String']>;
  promo_number_formatted?: Maybe<Scalars['String']>;
  tracking_url?: Maybe<Scalars['String']>;
  tty_formatted?: Maybe<Scalars['String']>;
};

export type CallCampaignProfile = {
  age: Scalars['Int'];
  family_size: Scalars['Int'];
  fpl: Scalars['String'];
  gender: Scalars['String'];
  qle: Scalars['String'];
  tobacco: Scalars['String'];
};

export type CallCampaignResponse = {
  __typename?: 'CallCampaignResponse';
  data?: Maybe<CallCampaignResponseData>;
};

export type CallCampaignResponseData = {
  __typename?: 'CallCampaignResponseData';
  advertiser?: Maybe<CallCampaignAdvertiser>;
  impression_id?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  phone?: Maybe<CallCampaignPhone>;
  placement?: Maybe<Scalars['String']>;
  schedule?: Maybe<CallCampaignSchedule>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type CallCampaignSchedule = {
  __typename?: 'CallCampaignSchedule';
  Thursday?: Maybe<CallCampaignDay>;
  friday?: Maybe<CallCampaignDay>;
  monday?: Maybe<CallCampaignDay>;
  saturday?: Maybe<CallCampaignDay>;
  sunday?: Maybe<CallCampaignDay>;
  tuesday?: Maybe<CallCampaignDay>;
  wednesday?: Maybe<CallCampaignDay>;
};

/** Payload to create a user session */
export type CreateSessionInput = {
  context: SessionContextInput;
};

/** Returned after successfully initializing a user session. */
export type CreateSessionResponse = {
  __typename?: 'CreateSessionResponse';
  /** User ID. Persists across sessions. */
  UserId?: Maybe<Scalars['String']>;
  /** A session, i.e. a single visit to the site. */
  sessionId?: Maybe<Scalars['String']>;
};

/** Used to track experiments at the session level. */
export type FlowContext = {
  __typename?: 'FlowContext';
  ExperimentId?: Maybe<Scalars['String']>;
  ExperimentVariation?: Maybe<Scalars['String']>;
  FlowId?: Maybe<Scalars['String']>;
  FlowStep?: Maybe<Scalars['String']>;
  FlowVersion?: Maybe<Scalars['String']>;
};

export type FlowContextInput = {
  ExperimentId?: InputMaybe<Scalars['String']>;
  ExperimentVariation?: InputMaybe<Scalars['String']>;
  FlowId?: InputMaybe<Scalars['String']>;
  FlowStep?: InputMaybe<Scalars['String']>;
  FlowVersion?: InputMaybe<Scalars['String']>;
};

/** Information about how a user was acquired. */
export type Label = {
  __typename?: 'Label';
  AdGroup?: Maybe<Scalars['String']>;
  AdGroupId?: Maybe<Scalars['String']>;
  AdId?: Maybe<Scalars['String']>;
  AdPosition?: Maybe<Scalars['String']>;
  AudienceId?: Maybe<Scalars['String']>;
  BiddingToolParameterError?: Maybe<Scalars['String']>;
  BiddingToolParameterStatus?: Maybe<Scalars['String']>;
  BiddingTool_Device?: Maybe<Scalars['String']>;
  BiddingTool_Leadid?: Maybe<Scalars['String']>;
  BiddingTool_TrafficSourceId?: Maybe<Scalars['String']>;
  BiddingTool_version?: Maybe<Scalars['String']>;
  Campaign?: Maybe<Scalars['String']>;
  CampaignId?: Maybe<Scalars['String']>;
  Channel?: Maybe<Scalars['String']>;
  Creative?: Maybe<Scalars['String']>;
  CreativeId?: Maybe<Scalars['String']>;
  Domain?: Maybe<Scalars['String']>;
  FeedItemId?: Maybe<Scalars['String']>;
  Gclid?: Maybe<Scalars['String']>;
  ImpactRadiusCampaignId?: Maybe<Scalars['String']>;
  Ircid?: Maybe<Scalars['String']>;
  Keyword?: Maybe<Scalars['String']>;
  KeywordId?: Maybe<Scalars['String']>;
  LandingPage?: Maybe<Scalars['String']>;
  LocationId?: Maybe<Scalars['String']>;
  MatchType?: Maybe<Scalars['String']>;
  Medium?: Maybe<Scalars['String']>;
  Network?: Maybe<Scalars['String']>;
  OptimizelyExperimentId?: Maybe<Scalars['String']>;
  Placement?: Maybe<Scalars['String']>;
  Product?: Maybe<Scalars['String']>;
  PublisherCampaignId?: Maybe<Scalars['String']>;
  QueryTxt?: Maybe<Scalars['String']>;
  RedirectionDomain?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
  Src?: Maybe<Scalars['String']>;
  SubId?: Maybe<Scalars['String']>;
  Target?: Maybe<Scalars['String']>;
  TargetId?: Maybe<Scalars['String']>;
  UtmRedirect?: Maybe<Scalars['String']>;
  agent_id?: Maybe<Scalars['String']>;
};

export type LabelInput = {
  AdGroup?: InputMaybe<Scalars['String']>;
  AdGroupId?: InputMaybe<Scalars['String']>;
  AdId?: InputMaybe<Scalars['String']>;
  AdPosition?: InputMaybe<Scalars['String']>;
  AudienceId?: InputMaybe<Scalars['String']>;
  BiddingToolParameterError?: InputMaybe<Scalars['String']>;
  BiddingToolParameterStatus?: InputMaybe<Scalars['String']>;
  BiddingTool_Device?: InputMaybe<Scalars['String']>;
  BiddingTool_Leadid?: InputMaybe<Scalars['String']>;
  BiddingTool_TrafficSourceId?: InputMaybe<Scalars['String']>;
  BiddingTool_version?: InputMaybe<Scalars['String']>;
  Campaign?: InputMaybe<Scalars['String']>;
  CampaignId?: InputMaybe<Scalars['String']>;
  Channel?: InputMaybe<Scalars['String']>;
  Creative?: InputMaybe<Scalars['String']>;
  CreativeId?: InputMaybe<Scalars['String']>;
  Domain?: InputMaybe<Scalars['String']>;
  FeedItemId?: InputMaybe<Scalars['String']>;
  Gclid?: InputMaybe<Scalars['String']>;
  ImpactRadiusCampaignId?: InputMaybe<Scalars['String']>;
  Ircid?: InputMaybe<Scalars['String']>;
  Keyword?: InputMaybe<Scalars['String']>;
  KeywordId?: InputMaybe<Scalars['String']>;
  LandingPage?: InputMaybe<Scalars['String']>;
  LocationId?: InputMaybe<Scalars['String']>;
  MatchType?: InputMaybe<Scalars['String']>;
  Medium?: InputMaybe<Scalars['String']>;
  Network?: InputMaybe<Scalars['String']>;
  OptimizelyExperimentId?: InputMaybe<Scalars['String']>;
  Placement?: InputMaybe<Scalars['String']>;
  Product?: InputMaybe<Scalars['String']>;
  PublisherCampaignId?: InputMaybe<Scalars['String']>;
  QueryTxt?: InputMaybe<Scalars['String']>;
  RedirectionDomain?: InputMaybe<Scalars['String']>;
  Source?: InputMaybe<Scalars['String']>;
  Src?: InputMaybe<Scalars['String']>;
  SubId?: InputMaybe<Scalars['String']>;
  Target?: InputMaybe<Scalars['String']>;
  TargetId?: InputMaybe<Scalars['String']>;
  UtmRedirect?: InputMaybe<Scalars['String']>;
  agent_id?: InputMaybe<Scalars['String']>;
};

export type LeadAuditPayload = {
  address1: Scalars['String'];
  city: Scalars['String'];
  dob: Scalars['String'];
  email: Scalars['String'];
  f_name: Scalars['String'];
  gender: Scalars['String'];
  l_name: Scalars['String'];
  phone1: Scalars['String'];
  state: Scalars['String'];
  tcpa_universal_id: Scalars['String'];
  zip: Scalars['String'];
};

export type LeadAuditResponse = {
  __typename?: 'LeadAuditResponse';
  data?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
};

/** Location information for a user, derived either from an IP address or ZIP code. */
export type Location = {
  __typename?: 'Location';
  /** The name of the city of the IP address. */
  city?: Maybe<Scalars['String']>;
  /** The country code of the location. */
  country?: Maybe<Scalars['String']>;
  /** The full name of the country. */
  countryName?: Maybe<Scalars['String']>;
  /** Numeric ID assigned to the county. */
  countyId?: Maybe<Scalars['Int']>;
  /** Name of the county */
  countyName?: Maybe<Scalars['String']>;
  /**
   * Standardized name containing the ZIP code, county, and state abbreviation.
   * It is not clear that this has any special significance, but it is returned
   * by the geolocation API and included for the sake of completeness.
   *
   * Example: 33133 - MIAMI-DADE COUNTY, FL
   */
  displayName?: Maybe<Scalars['String']>;
  /** Federal Information Processing System number assigned to the county. */
  fips?: Maybe<Scalars['String']>;
  /** The IP address used to look up the location, if one was used. */
  ip?: Maybe<Scalars['String']>;
  /** Latitude, to five decimal points. Only present if derived from an IP address. */
  latitude?: Maybe<Scalars['String']>;
  /** Longitude, to five decimal points. Only present if derived from an IP address. */
  longitude?: Maybe<Scalars['String']>;
  ssa?: Maybe<Scalars['String']>;
  /** Two-character state abbreviation */
  stateAbbreviation?: Maybe<Scalars['String']>;
  /** Numeric ID assigned to the state */
  stateId?: Maybe<Scalars['Int']>;
  /** U.S. state or territory */
  stateName?: Maybe<Scalars['String']>;
  /** ZIP code of the IP address. */
  zip?: Maybe<Scalars['String']>;
};

/** The root type for all mutation operations. */
export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Create a new session. If a user ID or email is provided, the API will attempt to link this
   * session to an existing user. If that fails, then a new user is created.
   */
  createSession: CreateSessionResponse;
  leadAudit?: Maybe<LeadAuditResponse>;
};


/** The root type for all mutation operations. */
export type MutationCreateSessionArgs = {
  payload: CreateSessionInput;
};


/** The root type for all mutation operations. */
export type MutationLeadAuditArgs = {
  payload: LeadAuditPayload;
};

/** The root type for all query operations */
export type Query = {
  __typename?: 'Query';
  getCallCampaign?: Maybe<CallCampaignResponse>;
  /** Get a location corresponding to an IP address. */
  getLocationFromIp: Array<Location>;
  /** Get the client's location using its IP address. */
  getLocationFromUserIp: Array<Location>;
  /** Get a location corresponding to a ZIP code. */
  getLocationFromZip: Array<Location>;
};


/** The root type for all query operations */
export type QueryGetCallCampaignArgs = {
  payload: CallCampaignPayload;
};


/** The root type for all query operations */
export type QueryGetLocationFromIpArgs = {
  ip: Scalars['String'];
};


/** The root type for all query operations */
export type QueryGetLocationFromZipArgs = {
  zip: Scalars['String'];
};

/**
 * "
 * Data related to a Tron session.
 *
 * From the Tron documentation:
 *
 * > A session is the period of time when a user accesses any of our flows, navigates them and interacts or not with our products.
 * The session is composed of 7 blocks of context that will be described in detail in a subsequent section.
 *
 * Users persist forever. Sessions last for only four hours, so a user may have many sessions.
 */
export type SessionContext = {
  __typename?: 'SessionContext';
  BiddingToolId?: Maybe<Scalars['String']>;
  BiddingToolName?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  FlowContext?: Maybe<FlowContext>;
  Label?: Maybe<Label>;
  Referrer?: Maybe<Scalars['String']>;
  TrafficContext?: Maybe<TrafficContext>;
  TrafficSource?: Maybe<Scalars['String']>;
  UserContext?: Maybe<UserContext>;
};

export type SessionContextInput = {
  BiddingToolId?: InputMaybe<Scalars['String']>;
  BiddingToolName?: InputMaybe<Scalars['String']>;
  Email?: InputMaybe<Scalars['String']>;
  FlowContext?: InputMaybe<FlowContextInput>;
  Label?: InputMaybe<LabelInput>;
  Referrer?: InputMaybe<Scalars['String']>;
  TrafficContext?: InputMaybe<TrafficContextInput>;
  TrafficSource?: InputMaybe<Scalars['String']>;
  UserContext?: InputMaybe<UserContextInput>;
};

/** Key-value map about traffic. */
export type TrafficContext = {
  __typename?: 'TrafficContext';
  Keys?: Maybe<Array<TrafficSourceKey>>;
  Provider?: Maybe<Scalars['String']>;
};

export type TrafficContextInput = {
  Keys?: InputMaybe<Array<TrafficSourceKeyInput>>;
  Provider?: InputMaybe<Scalars['String']>;
};

/** A single entry in the `TrafficContext` */
export type TrafficSourceKey = {
  __typename?: 'TrafficSourceKey';
  Name?: Maybe<Scalars['String']>;
  Value?: Maybe<Scalars['String']>;
};

export type TrafficSourceKeyInput = {
  Name?: InputMaybe<Scalars['String']>;
  Value?: InputMaybe<Scalars['String']>;
};

/** Basic information to identify a user. */
export type UserContext = {
  __typename?: 'UserContext';
  Browser?: Maybe<Scalars['String']>;
  BrowserVersion?: Maybe<Scalars['String']>;
  ClientId?: Maybe<Scalars['String']>;
  Device?: Maybe<Scalars['String']>;
  IpAddress?: Maybe<Scalars['String']>;
  IsNewUser?: Maybe<Scalars['Int']>;
  Location?: Maybe<Scalars['String']>;
  LoggedInAgentId?: Maybe<Scalars['String']>;
  Network?: Maybe<Scalars['String']>;
  OperatingSystem?: Maybe<Scalars['String']>;
  OperatingSystemVersion?: Maybe<Scalars['String']>;
  ParentSessionId?: Maybe<Scalars['String']>;
  SessionId?: Maybe<Scalars['String']>;
  UserAgent?: Maybe<Scalars['String']>;
  UserId?: Maybe<Scalars['String']>;
};

export type UserContextInput = {
  Browser?: InputMaybe<Scalars['String']>;
  BrowserVersion?: InputMaybe<Scalars['String']>;
  ClientId?: InputMaybe<Scalars['String']>;
  Device?: InputMaybe<Scalars['String']>;
  IpAddress?: InputMaybe<Scalars['String']>;
  IsNewUser?: InputMaybe<Scalars['Int']>;
  Location?: InputMaybe<Scalars['String']>;
  LoggedInAgentId?: InputMaybe<Scalars['String']>;
  Network?: InputMaybe<Scalars['String']>;
  OperatingSystem?: InputMaybe<Scalars['String']>;
  OperatingSystemVersion?: InputMaybe<Scalars['String']>;
  ParentSessionId?: InputMaybe<Scalars['String']>;
  SessionId?: InputMaybe<Scalars['String']>;
  UserAgent?: InputMaybe<Scalars['String']>;
  UserId?: InputMaybe<Scalars['String']>;
};

export type CreateSessionMutationVariables = Exact<{
  payload: CreateSessionInput;
}>;


export type CreateSessionMutation = { __typename?: 'Mutation', createSession: { __typename?: 'CreateSessionResponse', sessionId?: string | null, UserId?: string | null } };

export type GetInvocaCampaignQueryVariables = Exact<{
  payload: CallCampaignPayload;
}>;


export type GetInvocaCampaignQuery = { __typename?: 'Query', getCallCampaign?: { __typename?: 'CallCampaignResponse', data?: { __typename?: 'CallCampaignResponseData', placement?: string | null, logo?: string | null, zip?: string | null, impression_id?: string | null, advertiser?: { __typename?: 'CallCampaignAdvertiser', name?: string | null, logo?: string | null } | null, phone?: { __typename?: 'CallCampaignPhone', promo_number_formatted?: string | null, promo_number?: string | null, tracking_url?: string | null, link_invoca?: string | null, tty_formatted?: string | null } | null, schedule?: { __typename?: 'CallCampaignSchedule', sunday?: { __typename?: 'CallCampaignDay', from?: string | null, to?: string | null } | null, saturday?: { __typename?: 'CallCampaignDay', from?: string | null, to?: string | null } | null, tuesday?: { __typename?: 'CallCampaignDay', from?: string | null, to?: string | null } | null, Thursday?: { __typename?: 'CallCampaignDay', from?: string | null, to?: string | null } | null, wednesday?: { __typename?: 'CallCampaignDay', from?: string | null, to?: string | null } | null, friday?: { __typename?: 'CallCampaignDay', from?: string | null, to?: string | null } | null, monday?: { __typename?: 'CallCampaignDay', from?: string | null, to?: string | null } | null } | null } | null } | null };

export type GetLocationFromIpQueryVariables = Exact<{
  ip: Scalars['String'];
}>;


export type GetLocationFromIpQuery = { __typename?: 'Query', getLocationFromIp: Array<{ __typename?: 'Location', ip?: string | null, country?: string | null, countryName?: string | null, stateId?: number | null, stateName?: string | null, stateAbbreviation?: string | null, city?: string | null, zip?: string | null, latitude?: string | null, longitude?: string | null, countyId?: number | null, countyName?: string | null, fips?: string | null, ssa?: string | null, displayName?: string | null }> };

export type GetLocationFromUserIpQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationFromUserIpQuery = { __typename?: 'Query', getLocationFromUserIp: Array<{ __typename?: 'Location', ip?: string | null, country?: string | null, countryName?: string | null, stateId?: number | null, stateName?: string | null, stateAbbreviation?: string | null, city?: string | null, zip?: string | null, latitude?: string | null, longitude?: string | null, countyId?: number | null, countyName?: string | null, fips?: string | null, ssa?: string | null, displayName?: string | null }> };

export type GetLocationFromZipQueryVariables = Exact<{
  zip: Scalars['String'];
}>;


export type GetLocationFromZipQuery = { __typename?: 'Query', getLocationFromZip: Array<{ __typename?: 'Location', ip?: string | null, country?: string | null, countryName?: string | null, stateId?: number | null, stateName?: string | null, stateAbbreviation?: string | null, city?: string | null, zip?: string | null, latitude?: string | null, longitude?: string | null, countyId?: number | null, countyName?: string | null, fips?: string | null, ssa?: string | null, displayName?: string | null }> };

export type LeadAuditMutationVariables = Exact<{
  payload: LeadAuditPayload;
}>;


export type LeadAuditMutation = { __typename?: 'Mutation', leadAudit?: { __typename?: 'LeadAuditResponse', data?: string | null, error?: string | null, status?: number | null } | null };


export const CreateSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSessionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"payload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"UserId"}}]}}]}}]} as unknown as DocumentNode<CreateSessionMutation, CreateSessionMutationVariables>;
export const GetInvocaCampaignDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInvocaCampaign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CallCampaignPayload"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCallCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"payload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"placement"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"impression_id"}},{"kind":"Field","name":{"kind":"Name","value":"advertiser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promo_number_formatted"}},{"kind":"Field","name":{"kind":"Name","value":"promo_number"}},{"kind":"Field","name":{"kind":"Name","value":"tracking_url"}},{"kind":"Field","name":{"kind":"Name","value":"link_invoca"}},{"kind":"Field","name":{"kind":"Name","value":"tty_formatted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sunday"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"saturday"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tuesday"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Thursday"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wednesday"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"friday"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"monday"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetInvocaCampaignQuery, GetInvocaCampaignQueryVariables>;
export const GetLocationFromIpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLocationFromIp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLocationFromIp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countryName"}},{"kind":"Field","name":{"kind":"Name","value":"stateId"}},{"kind":"Field","name":{"kind":"Name","value":"stateName"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"countyId"}},{"kind":"Field","name":{"kind":"Name","value":"countyName"}},{"kind":"Field","name":{"kind":"Name","value":"fips"}},{"kind":"Field","name":{"kind":"Name","value":"ssa"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<GetLocationFromIpQuery, GetLocationFromIpQueryVariables>;
export const GetLocationFromUserIpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLocationFromUserIp"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLocationFromUserIp"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countryName"}},{"kind":"Field","name":{"kind":"Name","value":"stateId"}},{"kind":"Field","name":{"kind":"Name","value":"stateName"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"countyId"}},{"kind":"Field","name":{"kind":"Name","value":"countyName"}},{"kind":"Field","name":{"kind":"Name","value":"fips"}},{"kind":"Field","name":{"kind":"Name","value":"ssa"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<GetLocationFromUserIpQuery, GetLocationFromUserIpQueryVariables>;
export const GetLocationFromZipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLocationFromZip"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLocationFromZip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countryName"}},{"kind":"Field","name":{"kind":"Name","value":"stateId"}},{"kind":"Field","name":{"kind":"Name","value":"stateName"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"countyId"}},{"kind":"Field","name":{"kind":"Name","value":"countyName"}},{"kind":"Field","name":{"kind":"Name","value":"fips"}},{"kind":"Field","name":{"kind":"Name","value":"ssa"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<GetLocationFromZipQuery, GetLocationFromZipQueryVariables>;
export const LeadAuditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LeadAudit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LeadAuditPayload"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leadAudit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"payload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<LeadAuditMutation, LeadAuditMutationVariables>;